<div class="grid__cell grid__cell--widget widget__bag" [dragula]='"widget-bag"'>
  <div class="widget__wrap">
    <div class="widget" id="pages-widget">
      <h2 class="widget__header">
        <span class="widget__header__title">
          <i class="widget__header__icon ico-angle-down"></i> Odběratelé</span>
        <span class="widget__header__tools">
          <swb-filter-list (modelChange)="filterSubscribers($event)"></swb-filter-list>
          <a [routerLink]="['subscribers/add']" class="cta cta--small cta--green">
            <span class="cta__light">Přidat</span> odběratele
            <i class="ico-plus"></i>
          </a>
        </span>
      </h2>
      <div class="widget__content">
        <swb-subscribers [query]="subscribersQuery"></swb-subscribers>
      </div>
    </div>
  </div>
</div>
<div class="grid__cell grid__cell--widget widget__bag" [dragula]='"widget-bag"'>
  <div class="widget__wrap">
    <div class="widget" id="pages-widget">
      <h2 class="widget__header">
        <span class="widget__header__title">
          <i class="widget__header__icon ico-angle-down"></i> Kampaně</span>
        <span class="widget__header__tools">
          <swb-filter-list (modelChange)="filterCampaigns($event)"></swb-filter-list>
          <a [routerLink]="['campaigns/add']" class="cta cta--small cta--green">
            <span class="cta__light">Nová</span> kampaň
            <i class="ico-plus"></i>
          </a>
        </span>
      </h2>
      <div class="widget__content">
        <swb-campaigns-list [query]="campaignsQuery"></swb-campaigns-list>
        <p class="infobox"><fa-icon [icon]="['fas', 'info']"></fa-icon> &nbsp; Pro aktivaci rozesílání Newsletterů kontaktujte 7divs.</p>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>